// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"TableSectionTitle_sectionTitle_1xA7X","sectionLabel":"TableSectionTitle_sectionLabel_2yQrD","tableCollapseToggle":"TableSectionTitle_tableCollapseToggle_2Vn8n"};